import React, { useContext, useState, useEffect, useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAccount } from 'wagmi';

import { MobileContext } from 'context';
import { useGameDetails, useCurrentRound, useNewestRoundID, useHistoricRound } from 'utils/Hooks';
import CrossChainReferrerUpdater from 'components/Referrals/crosschain_updater';
import PredictionDesktop from './desktop';
import PredictionMobile from './mobile';
import PredictionHeadline from 'components/Headline';
import 'styles/responsiveness.scss';
import 'components/CardBase/cards.scss';


function PredictionComponent(props) {
  const errorReportingDelay = 4500;

  const queryClient = useQueryClient();
  const gameDetails = useGameDetails(); // former 'predictionData'
  const newestRoundID = useNewestRoundID();
  const currentRound = useCurrentRound();

  const account = useAccount();

  const isMobile = useContext(MobileContext);
  const [isLoaded, SetLoadedStatus] = useState(false);


  useEffect(() => {
    if (newestRoundID > 0)
      queryClient.invalidateQueries({
        queryKey: ['newestRoundID', gameDetails.contracts.prediction?._address, gameDetails.wantedChain.id],
      });
  }, [newestRoundID]);


  const mPredictionsInterface = useMemo(PredictionsInterface
    , [isMobile, newestRoundID, currentRound, gameDetails, account?.address]);
  function PredictionsInterface() {
    return (
      <React.Fragment>
        <CrossChainReferrerUpdater />
        {isMobile ? (
          <PredictionMobile
            newestRoundID={newestRoundID}
            OnLoad={() => SetLoadedStatus(true)}
          />
        ) : (
          <PredictionDesktop
            newestRoundID={newestRoundID}
            OnLoad={() => SetLoadedStatus(true)}
          />
        )}
      </React.Fragment>
    );
  }


  if (!newestRoundID) {
    return null;
  } else {
    return (<React.Fragment>
      <div className='GameStatus'>
        <PredictionHeadline />
      </div>
      {mPredictionsInterface}
      {/* <PageBackground /> */}
    </React.Fragment>
    );
  }
}

export default PredictionComponent;
